/**
 * Visited page data for each partner.
 */
export class PartnerVisits {
  /**
   * The last time the user was shown a layer from a partner.
   */
  lastLayerShown: number;

  /**
   * The list of partners that have been visited and their related data.
   */
  partners: Record<string, PartnerData>;

  constructor() {
    this.lastLayerShown = 0;
    this.partners = {};
  }
}

/**
 * Stores visit count and last visit for a partner.
 */
export class PartnerData {
  /**
   * The number of times the user has visited a partner page.
   */
  visits: number;

  /**
   * The last time the user visited the partner page.
   * The timestamp format is the same returned by Date.now().
   */
  lastVisit: number;
}
